module.exports = __webpack_public_path__ + "img/premium-tag-03-es.29e8324e.svg";